




















import { Vue, Component, Prop } from 'vue-property-decorator'
@Component

export default class RunStatusAll extends Vue {
    @Prop() status!: number
  //    * 运行中     1
  //  * 停用       2
  //  * 已结束     3
  //  * 未开始     4
}
